import { useEffect, useState } from "react";
import GalleryPage from "./componentes/Galery";
import FeaturedInauguracao from "./componentes/CardStar";

export default function Inauguracoes({ subStep }) {
  const [data, setData] = useState([]);

  useEffect(() => {
    async function fetchData() {
      const res = await fetch(`${process.env.REACT_APP_API_URL}/api/inauguracoes/`);
      const json = await res.json();
      setData(json);
    }

    fetchData();
  }, []);

  if (!data.length) return <div className="p-10">Carregando...</div>;

  const featured = data[0];
  const rest = data.slice(1);

  const regionOrder = ["Sul", "Norte", "Leste", "Centro-Oeste"];

  const grouped = regionOrder.reduce((acc, region) => {
    acc[region] = rest.filter((item) => item.regiao === region);
    return acc;
  }, {});

  const allCards = Object.values(grouped).flat();
  console.log(allCards);
  const mid = Math.ceil(allCards.length / 2);

  const page1 = allCards.slice(0, mid);
  const page2 = allCards.slice(mid);

  return (
    <div className="px-20 py-10">
      {subStep === 1 && <FeaturedInauguracao featured={featured} />}

      {subStep === 2 && <GalleryPage items={page1} />}

      {subStep === 3 && <GalleryPage items={page2} />}
    </div>
  );
}
